window.GiftLetterFirebase = (() => {
  const firebaseConfig = {
    apiKey: "AIzaSyCtZOuM3_J6c9fJn-ZkaA_7glTWa9mMq7Y",
    authDomain: "giftletters-814c6.firebaseapp.com",
    projectId: "giftletters-814c6",
    storageBucket: "giftletters-814c6.firebasestorage.app",
    messagingSenderId: "272932758603",
    appId: "1:272932758603:web:4466a542d38c3330a3d9ce",
    measurementId: "G-S9DG68Y8RC"
  };

  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
  }

  const app = firebase.app();
  const auth = firebase.auth ? firebase.auth() : null;
  const db = firebase.firestore();
  const storage = firebase.storage ? firebase.storage() : null;

  function getQueryParam(name) {
    const url = new URL(window.location.href);
    return url.searchParams.get(name);
  }

  function generateId(prefix = "id") {
    return `${prefix}_${Math.random().toString(36).slice(2, 10)}`;
  }

  function generateToken() {
    return Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
  }

function replaceSlackEmojiShortcodes(text = "") {
    const emojiMap = {
    ":farmer:": "🧑‍🌾",
    ":snow_capped_mountain:": "🏔️",
    ":ocean:": "🌊",
    ":jp:": "🗾",
    ":grinning:": "😀",
    ":smiley:": "😃",
    ":smile:": "😄",
    ":grin:": "😁",
    ":laughing:": "😆",
    ":sweat_smile:": "😅",
    ":joy:": "😂",
    ":rofl:": "🤣",
    ":relaxed:": "☺️",
    ":blush:": "😊",
    ":innocent:": "😇",
    ":slightly_smiling_face:": "🙂",
    ":upside_down_face:": "🙃",
    ":wink:": "😉",
    ":relieved:": "😌",
    ":heart_eyes:": "😍",
    ":kissing_heart:": "😘",
    ":kissing:": "😗",
    ":kissing_smiling_eyes:": "😙",
    ":kissing_closed_eyes:": "😚",
    ":yum:": "😋",
    ":stuck_out_tongue:": "😛",
    ":stuck_out_tongue_winking_eye:": "😜",
    ":zany_face:": "🤪",
    ":stuck_out_tongue_closed_eyes:": "😝",
    ":money_mouth_face:": "🤑",
    ":hugs:": "🤗",
    ":hand_over_mouth:": "🤭",
    ":shushing_face:": "🤫",
    ":thinking_face:": "🤔",
    ":zipper_mouth_face:": "🤐",
    ":raised_eyebrow:": "🤨",
    ":neutral_face:": "😐",
    ":expressionless:": "😑",
    ":no_mouth:": "😶",
    ":smirk:": "😏",
    ":unamused:": "😒",
    ":roll_eyes:": "🙄",
    ":grimacing:": "😬",
    ":lying_face:": "🤥",
    ":shaking_face:": "🫨",
    ":relieved_face:": "😌",
    ":pensive:": "😔",
    ":sleepy:": "😪",
    ":drooling_face:": "🤤",
    ":sleeping:": "😴",
    ":mask:": "😷",
    ":face_with_thermometer:": "🤒",
    ":face_with_head_bandage:": "🤕",
    ":nauseated_face:": "🤢",
    ":vomiting_face:": "🤮",
    ":sneezing_face:": "🤧",
    ":hot_face:": "🥵",
    ":cold_face:": "🥶",
    ":woozy_face:": "🥴",
    ":dizzy_face:": "😵",
    ":exploding_head:": "🤯",
    ":cowboy_hat_face:": "🤠",
    ":partying_face:": "🥳",
    ":disguised_face:": "🥸",
    ":sunglasses:": "😎",
    ":nerd_face:": "🤓",
    ":monocle_face:": "🧐",
    ":confused:": "😕",
    ":face_with_diagonal_mouth:": "🫤",
    ":worried:": "😟",
    ":slightly_frowning_face:": "🙁",
    ":frowning_face:": "☹️",
    ":open_mouth:": "😮",
    ":hushed:": "😯",
    ":astonished:": "😲",
    ":flushed:": "😳",
    ":pleading_face:": "🥺",
    ":frowning:": "😦",
    ":anguished:": "😧",
    ":fearful:": "😨",
    ":cold_sweat:": "😰",
    ":disappointed_relieved:": "😥",
    ":cry:": "😢",
    ":sob:": "😭",
    ":scream:": "😱",
    ":confounded:": "😖",
    ":persevere:": "😣",
    ":disappointed:": "😞",
    ":sweat:": "😓",
    ":weary:": "😩",
    ":tired_face:": "😫",
    ":yawning_face:": "🥱",
    ":triumph:": "😤",
    ":rage:": "😡",
    ":angry:": "😠",
    ":cursing_face:": "🤬",
    ":smiling_imp:": "😈",
    ":imp:": "👿",
    ":skull:": "💀",
    ":skull_and_crossbones:": "☠️",
    ":poop:": "💩",
    ":clown_face:": "🤡",
    ":japanese_ogre:": "👹",
    ":japanese_goblin:": "👺",
    ":ghost:": "👻",
    ":alien:": "👽",
    ":space_invader:": "👾",
    ":robot_face:": "🤖",
    ":smiley_cat:": "😺",
    ":smile_cat:": "😸",
    ":joy_cat:": "😹",
    ":heart_eyes_cat:": "😻",
    ":smirk_cat:": "😼",
    ":kissing_cat:": "😽",
    ":scream_cat:": "🙀",
    ":crying_cat_face:": "😿",
    ":pouting_cat:": "😾",

    ":wave:": "👋",
    ":raised_back_of_hand:": "🤚",
    ":raised_hand_with_fingers_splayed:": "🖐️",
    ":hand:": "✋",
    ":vulcan_salute:": "🖖",
    ":rightwards_hand:": "🫱",
    ":leftwards_hand:": "🫲",
    ":ok_hand:": "👌",
    ":pinched_fingers:": "🤌",
    ":pinching_hand:": "🤏",
    ":v:": "✌️",
    ":crossed_fingers:": "🤞",
    ":hand_with_index_finger_and_thumb_crossed:": "🫰",
    ":love_you_gesture:": "🤟",
    ":metal:": "🤘",
    ":call_me_hand:": "🤙",
    ":point_left:": "👈",
    ":point_right:": "👉",
    ":point_up_2:": "👆",
    ":middle_finger:": "🖕",
    ":point_down:": "👇",
    ":point_up:": "☝️",
    ":index_pointing_at_the_viewer:": "🫵",
    ":thumbsup:": "👍",
    ":+1:": "👍",
    ":thumbsdown:": "👎",
    ":-1:": "👎",
    ":fist_raised:": "✊",
    ":fist_oncoming:": "👊",
    ":fist_left:": "🤛",
    ":fist_right:": "🤜",
    ":clap:": "👏",
    ":raised_hands:": "🙌",
    ":heart_hands:": "🫶",
    ":open_hands:": "👐",
    ":palms_up_together:": "🤲",
    ":handshake:": "🤝",
    ":pray:": "🙏",
    ":writing_hand:": "✍️",
    ":nail_care:": "💅",
    ":selfie:": "🤳",
    ":muscle:": "💪",
    ":mechanical_arm:": "🦾",
    ":mechanical_leg:": "🦿",
    ":leg:": "🦵",
    ":foot:": "🦶",
    ":ear:": "👂",
    ":ear_with_hearing_aid:": "🦻",
    ":nose:": "👃",
    ":brain:": "🧠",
    ":anatomical_heart:": "🫀",
    ":lungs:": "🫁",
    ":tooth:": "🦷",
    ":bone:": "🦴",
    ":eyes:": "👀",
    ":eye:": "👁️",
    ":tongue:": "👅",
    ":mouth:": "👄",

    ":baby:": "👶",
    ":child:": "🧒",
    ":boy:": "👦",
    ":girl:": "👧",
    ":adult:": "🧑",
    ":person_blond_hair:": "👱",
    ":man:": "👨",
    ":bearded_person:": "🧔",
    ":woman:": "👩",
    ":older_adult:": "🧓",
    ":older_man:": "👴",
    ":older_woman:": "👵",
    ":person_frowning:": "🙍",
    ":person_pouting:": "🙎",
    ":person_gesturing_no:": "🙅",
    ":person_gesturing_ok:": "🙆",
    ":person_tipping_hand:": "💁",
    ":person_raising_hand:": "🙋",
    ":deaf_person:": "🧏",
    ":person_bowing:": "🙇",
    ":woman-bowing:": "🙇‍♀️",
    ":man-bowing:": "🙇‍♂️",
    ":person_facepalming:": "🤦",
    ":person_shrugging:": "🤷",
    ":person_health_worker:": "🧑‍⚕️",
    ":person_student:": "🧑‍🎓",
    ":person_teacher:": "🧑‍🏫",
    ":person_judge:": "🧑‍⚖️",
    ":person_farmer:": "🧑‍🌾",
    ":person_cook:": "🧑‍🍳",
    ":person_mechanic:": "🧑‍🔧",
    ":person_factory_worker:": "🧑‍🏭",
    ":person_office_worker:": "🧑‍💼",
    ":person_scientist:": "🧑‍🔬",
    ":person_technologist:": "🧑‍💻",
    ":person_singer:": "🧑‍🎤",
    ":person_artist:": "🧑‍🎨",
    ":person_pilot:": "🧑‍✈️",
    ":person_astronaut:": "🧑‍🚀",
    ":person_firefighter:": "🧑‍🚒",
    ":police_officer:": "👮",
    ":detective:": "🕵️",
    ":guard:": "💂",
    ":ninja:": "🥷",
    ":construction_worker:": "👷",
    ":prince:": "🤴",
    ":princess:": "👸",
    ":person_wearing_turban:": "👳",
    ":person_with_skullcap:": "👲",
    ":woman_with_headscarf:": "🧕",
    ":person_in_tuxedo:": "🤵",
    ":person_with_veil:": "👰",
    ":pregnant_woman:": "🤰",
    ":breast_feeding:": "🤱",
    ":angel:": "👼",
    ":santa:": "🎅",
    ":mrs_claus:": "🤶",
    ":superhero:": "🦸",
    ":supervillain:": "🦹",
    ":mage:": "🧙",
    ":fairy:": "🧚",
    ":vampire:": "🧛",
    ":merperson:": "🧜",
    ":elf:": "🧝",
    ":genie:": "🧞",
    ":zombie:": "🧟",
    ":massage:": "💆",
    ":haircut:": "💇",
    ":walking:": "🚶",
    ":standing_person:": "🧍",
    ":kneeling_person:": "🧎",
    ":person_with_white_cane:": "🧑‍🦯",
    ":person_in_motorized_wheelchair:": "🧑‍🦼",
    ":person_in_manual_wheelchair:": "🧑‍🦽",
    ":runner:": "🏃",
    ":woman_dancing:": "💃",
    ":man_dancing:": "🕺",
    ":people_with_bunny_ears_partying:": "👯",
    ":person_in_steamy_room:": "🧖",
    ":person_climbing:": "🧗",
    ":person_fencing:": "🤺",
    ":horse_racing:": "🏇",
    ":skier:": "⛷️",
    ":snowboarder:": "🏂",
    ":golfing:": "🏌️",
    ":surfing:": "🏄",
    ":rowing_boat:": "🚣",
    ":swimming:": "🏊",
    ":bouncing_ball_person:": "⛹️",
    ":weight_lifting:": "🏋️",
    ":biking:": "🚴",
    ":mountain_biking:": "🚵",
    ":person_cartwheeling:": "🤸",
    ":wrestling:": "🤼",
    ":water_polo:": "🤽",
    ":handball:": "🤾",
    ":juggling_person:": "🤹",
    ":lotus_position:": "🧘",
    ":bath:": "🛀",
    ":sleeping_bed:": "🛌",
    ":people_holding_hands:": "🧑‍🤝‍🧑",
    ":bust_in_silhouette:": "👤",
    ":busts_in_silhouette:": "👥",

    ":monkey_face:": "🐵",
    ":monkey:": "🐒",
    ":gorilla:": "🦍",
    ":orangutan:": "🦧",
    ":dog:": "🐶",
    ":dog2:": "🐕",
    ":poodle:": "🐩",
    ":wolf:": "🐺",
    ":fox_face:": "🦊",
    ":raccoon:": "🦝",
    ":cat:": "🐱",
    ":cat2:": "🐈",
    ":lion_face:": "🦁",
    ":tiger:": "🐯",
    ":tiger2:": "🐅",
    ":leopard:": "🐆",
    ":horse:": "🐴",
    ":racehorse:": "🐎",
    ":zebra_face:": "🦓",
    ":deer:": "🦌",
    ":bison:": "🦬",
    ":cow:": "🐮",
    ":ox:": "🐂",
    ":water_buffalo:": "🐃",
    ":cow2:": "🐄",
    ":pig:": "🐷",
    ":pig2:": "🐖",
    ":boar:": "🐗",
    ":pig_nose:": "🐽",
    ":ram:": "🐏",
    ":sheep:": "🐑",
    ":goat:": "🐐",
    ":dromedary_camel:": "🐪",
    ":camel:": "🐫",
    ":llama:": "🦙",
    ":giraffe_face:": "🦒",
    ":elephant:": "🐘",
    ":mammoth:": "🦣",
    ":rhinoceros:": "🦏",
    ":hippopotamus:": "🦛",
    ":mouse:": "🐭",
    ":mouse2:": "🐁",
    ":rat:": "🐀",
    ":hamster:": "🐹",
    ":rabbit:": "🐰",
    ":rabbit2:": "🐇",
    ":chipmunk:": "🐿️",
    ":beaver:": "🦫",
    ":hedgehog:": "🦔",
    ":bat:": "🦇",
    ":bear:": "🐻",
    ":polar_bear:": "🐻‍❄️",
    ":koala:": "🐨",
    ":panda_face:": "🐼",
    ":sloth:": "🦥",
    ":otter:": "🦦",
    ":skunk:": "🦨",
    ":kangaroo:": "🦘",
    ":badger:": "🦡",
    ":feet:": "🐾",
    ":turkey:": "🦃",
    ":chicken:": "🐔",
    ":rooster:": "🐓",
    ":hatching_chick:": "🐣",
    ":baby_chick:": "🐤",
    ":hatched_chick:": "🐥",
    ":bird:": "🐦",
    ":penguin:": "🐧",
    ":dove_of_peace:": "🕊️",
    ":eagle:": "🦅",
    ":duck:": "🦆",
    ":swan:": "🦢",
    ":owl:": "🦉",
    ":dodo:": "🦤",
    ":feather:": "🪶",
    ":flamingo:": "🦩",
    ":peacock:": "🦚",
    ":parrot:": "🦜",
    ":wing:": "🪽",
    ":black_bird:": "🐦‍⬛",
    ":goose:": "🪿",
    ":frog:": "🐸",
    ":crocodile:": "🐊",
    ":turtle:": "🐢",
    ":lizard:": "🦎",
    ":snake:": "🐍",
    ":dragon_face:": "🐲",
    ":dragon:": "🐉",
    ":sauropod:": "🦕",
    ":t-rex:": "🦖",
    ":whale:": "🐳",
    ":whale2:": "🐋",
    ":dolphin:": "🐬",
    ":seal:": "🦭",
    ":fish:": "🐟",
    ":tropical_fish:": "🐠",
    ":blowfish:": "🐡",
    ":shark:": "🦈",
    ":octopus:": "🐙",
    ":shell:": "🐚",
    ":coral:": "🪸",
    ":jellyfish:": "🪼",
    ":snail:": "🐌",
    ":butterfly:": "🦋",
    ":bug:": "🐛",
    ":ant:": "🐜",
    ":bee:": "🐝",
    ":beetle:": "🪲",
    ":lady_beetle:": "🐞",
    ":cricket:": "🦗",
    ":cockroach:": "🪳",
    ":spider:": "🕷️",
    ":spider_web:": "🕸️",
    ":scorpion:": "🦂",
    ":mosquito:": "🦟",
    ":fly:": "🪰",
    ":worm:": "🪱",
    ":microbe:": "🦠",

    ":cherry_blossom:": "🌸",
    ":white_flower:": "💮",
    ":lotus:": "🪷",
    ":rosette:": "🏵️",
    ":rose:": "🌹",
    ":wilted_flower:": "🥀",
    ":hibiscus:": "🌺",
    ":sunflower:": "🌻",
    ":blossom:": "🌼",
    ":tulip:": "🌷",
    ":hyacinth:": "🪻",
    ":seedling:": "🌱",
    ":potted_plant:": "🪴",
    ":evergreen_tree:": "🌲",
    ":deciduous_tree:": "🌳",
    ":palm_tree:": "🌴",
    ":cactus:": "🌵",
    ":ear_of_rice:": "🌾",
    ":herb:": "🌿",
    ":shamrock:": "☘️",
    ":four_leaf_clover:": "🍀",
    ":maple_leaf:": "🍁",
    ":fallen_leaf:": "🍂",
    ":leaves:": "🍃",
    ":empty_nest:": "🪹",
    ":nest_with_eggs:": "🪺",
    ":mushroom:": "🍄",

    ":grapes:": "🍇",
    ":melon:": "🍈",
    ":watermelon:": "🍉",
    ":tangerine:": "🍊",
    ":lemon:": "🍋",
    ":banana:": "🍌",
    ":pineapple:": "🍍",
    ":mango:": "🥭",
    ":apple:": "🍎",
    ":green_apple:": "🍏",
    ":pear:": "🍐",
    ":peach:": "🍑",
    ":cherries:": "🍒",
    ":strawberry:": "🍓",
    ":blueberries:": "🫐",
    ":kiwifruit:": "🥝",
    ":tomato:": "🍅",
    ":olive:": "🫒",
    ":coconut:": "🥥",
    ":avocado:": "🥑",
    ":eggplant:": "🍆",
    ":potato:": "🥔",
    ":carrot:": "🥕",
    ":corn:": "🌽",
    ":hot_pepper:": "🌶️",
    ":bell_pepper:": "🫑",
    ":cucumber:": "🥒",
    ":leafy_green:": "🥬",
    ":broccoli:": "🥦",
    ":garlic:": "🧄",
    ":onion:": "🧅",
    ":peanuts:": "🥜",
    ":beans:": "🫘",
    ":chestnut:": "🌰",
    ":bread:": "🍞",
    ":croissant:": "🥐",
    ":baguette_bread:": "🥖",
    ":flatbread:": "🫓",
    ":pretzel:": "🥨",
    ":bagel:": "🥯",
    ":pancakes:": "🥞",
    ":waffle:": "🧇",
    ":cheese_wedge:": "🧀",
    ":meat_on_bone:": "🍖",
    ":poultry_leg:": "🍗",
    ":cut_of_meat:": "🥩",
    ":bacon:": "🥓",
    ":hamburger:": "🍔",
    ":fries:": "🍟",
    ":pizza:": "🍕",
    ":hotdog:": "🌭",
    ":sandwich:": "🥪",
    ":taco:": "🌮",
    ":burrito:": "🌯",
    ":tamale:": "🫔",
    ":stuffed_flatbread:": "🥙",
    ":falafel:": "🧆",
    ":egg:": "🥚",
    ":fried_egg:": "🍳",
    ":shallow_pan_of_food:": "🥘",
    ":stew:": "🍲",
    ":fondue:": "🫕",
    ":bowl_with_spoon:": "🥣",
    ":green_salad:": "🥗",
    ":popcorn:": "🍿",
    ":butter:": "🧈",
    ":salt:": "🧂",
    ":canned_food:": "🥫",
    ":bento:": "🍱",
    ":rice_cracker:": "🍘",
    ":rice_ball:": "🍙",
    ":rice:": "🍚",
    ":curry:": "🍛",
    ":ramen:": "🍜",
    ":spaghetti:": "🍝",
    ":sweet_potato:": "🍠",
    ":oden:": "🍢",
    ":sushi:": "🍣",
    ":fried_shrimp:": "🍤",
    ":fish_cake:": "🍥",
    ":moon_cake:": "🥮",
    ":dango:": "🍡",
    ":dumpling:": "🥟",
    ":fortune_cookie:": "🥠",
    ":takeout_box:": "🥡",
    ":crab:": "🦀",
    ":lobster:": "🦞",
    ":shrimp:": "🦐",
    ":squid:": "🦑",
    ":oyster:": "🦪",
    ":soft_ice_cream:": "🍦",
    ":ice_cream:": "🍨",
    ":shaved_ice:": "🍧",
    ":icecream:": "🍦",
    ":doughnut:": "🍩",
    ":cookie:": "🍪",
    ":birthday:": "🎂",
    ":cake:": "🍰",
    ":cupcake:": "🧁",
    ":pie:": "🥧",
    ":chocolate_bar:": "🍫",
    ":candy:": "🍬",
    ":lollipop:": "🍭",
    ":custard:": "🍮",
    ":honey_pot:": "🍯",
    ":baby_bottle:": "🍼",
    ":milk_glass:": "🥛",
    ":coffee:": "☕",
    ":teapot:": "🫖",
    ":tea:": "🍵",
    ":sake:": "🍶",
    ":champagne:": "🍾",
    ":wine_glass:": "🍷",
    ":cocktail:": "🍸",
    ":tropical_drink:": "🍹",
    ":beer:": "🍺",
    ":beers:": "🍻",
    ":clinking_glasses:": "🥂",
    ":tumbler_glass:": "🥃",
    ":pouring_liquid:": "🫗",
    ":cup_with_straw:": "🥤",
    ":bubble_tea:": "🧋",
    ":beverage_box:": "🧃",
    ":mate:": "🧉",
    ":ice_cube:": "🧊",
    ":chopsticks:": "🥢",
    ":fork_and_knife:": "🍴",
    ":spoon:": "🥄",
    ":kitchen_knife:": "🔪",
    ":jar:": "🫙",
    ":amphora:": "🏺",

    ":heart:": "❤️",
    ":orange_heart:": "🧡",
    ":yellow_heart:": "💛",
    ":green_heart:": "💚",
    ":blue_heart:": "💙",
    ":purple_heart:": "💜",
    ":black_heart:": "🖤",
    ":grey_heart:": "🩶",
    ":white_heart:": "🤍",
    ":brown_heart:": "🤎",
    ":broken_heart:": "💔",
    ":heart_exclamation:": "❣️",
    ":two_hearts:": "💕",
    ":revolving_hearts:": "💞",
    ":heartbeat:": "💓",
    ":heartpulse:": "💗",
    ":sparkling_heart:": "💖",
    ":cupid:": "💘",
    ":gift_heart:": "💝",
    ":mending_heart:": "❤️‍🩹",
    ":fire:": "🔥",
    ":star:": "⭐",
    ":star2:": "🌟",
    ":dizzy:": "💫",
    ":sparkles:": "✨",
    ":boom:": "💥",
    ":collision:": "💥",
    ":anger:": "💢",
    ":sweat_drops:": "💦",
    ":dash:": "💨",
    ":hole:": "🕳️",
    ":speech_balloon:": "💬",
    ":eye_in_speech_bubble:": "👁️‍🗨️",
    ":left_speech_bubble:": "🗨️",
    ":right_anger_bubble:": "🗯️",
    ":thought_balloon:": "💭",
    ":zzz:": "💤",

    ":sunny:": "☀️",
    ":partly_sunny:": "⛅",
    ":cloud:": "☁️",
    ":cloud_with_lightning_and_rain:": "⛈️",
    ":sun_behind_small_cloud:": "🌤️",
    ":sun_behind_large_cloud:": "🌥️",
    ":sun_behind_rain_cloud:": "🌦️",
    ":cloud_with_rain:": "🌧️",
    ":cloud_with_snow:": "🌨️",
    ":cloud_with_lightning:": "🌩️",
    ":tornado:": "🌪️",
    ":fog:": "🌫️",
    ":wind_face:": "🌬️",
    ":cyclone:": "🌀",
    ":rainbow:": "🌈",
    ":closed_umbrella:": "🌂",
    ":open_umbrella:": "☂️",
    ":umbrella:": "☔",
    ":umbrella_with_rain_drops:": "☔",
    ":zap:": "⚡",
    ":snowflake:": "❄️",
    ":snowman_with_snow:": "☃️",
    ":snowman:": "⛄",
    ":comet:": "☄️",
    ":firecracker:": "🧨",
    ":sparkler:": "🎇",
    ":fireworks:": "🎆",

    ":tada:": "🎉",
    ":confetti_ball:": "🎊",
    ":balloon:": "🎈",
    ":gift:": "🎁",
    ":tickets:": "🎟️",
    ":medal_military:": "🎖️",
    ":trophy:": "🏆",
    ":medal_sports:": "🏅",
    ":1st_place_medal:": "🥇",
    ":2nd_place_medal:": "🥈",
    ":3rd_place_medal:": "🥉",

    ":soccer:": "⚽",
    ":baseball:": "⚾",
    ":softball:": "🥎",
    ":basketball:": "🏀",
    ":volleyball:": "🏐",
    ":football:": "🏈",
    ":rugby_football:": "🏉",
    ":tennis:": "🎾",
    ":flying_disc:": "🥏",
    ":bowling:": "🎳",
    ":cricket_game:": "🏏",
    ":field_hockey_stick_and_ball:": "🏑",
    ":ice_hockey_stick_and_puck:": "🏒",
    ":lacrosse:": "🥍",
    ":ping_pong:": "🏓",
    ":badminton_racquet_and_shuttlecock:": "🏸",
    ":boxing_glove:": "🥊",
    ":martial_arts_uniform:": "🥋",
    ":goal_net:": "🥅",
    ":golf:": "⛳",
    ":ice_skate:": "⛸️",
    ":fishing_pole_and_fish:": "🎣",
    ":diving_mask:": "🤿",

    ":guitar:": "🎸",
    ":musical_keyboard:": "🎹",
    ":trumpet:": "🎺",
    ":violin:": "🎻",
    ":banjo:": "🪕",
    ":drum:": "🥁",
    ":long_drum:": "🪘",
    ":maracas:": "🪇",
    ":saxophone:": "🎷",
    ":accordion:": "🪗",
    ":microphone:": "🎤",
    ":headphones:": "🎧",
    ":radio:": "📻",
    ":clapper:": "🎬",
    ":performing_arts:": "🎭",
    ":art:": "🎨",
    ":camera:": "📷",
    ":camera_with_flash:": "📸",
    ":video_camera:": "📹",
    ":movie_camera:": "🎥",
    ":film_projector:": "📽️",
    ":film_frames:": "🎞️",

    ":iphone:": "📱",
    ":calling:": "📲",
    ":telephone_receiver:": "📞",
    ":pager:": "📟",
    ":fax:": "📠",
    ":battery:": "🔋",
    ":low_battery:": "🪫",
    ":electric_plug:": "🔌",
    ":computer:": "💻",
    ":desktop_computer:": "🖥️",
    ":printer:": "🖨️",
    ":keyboard:": "⌨️",
    ":computer_mouse:": "🖱️",
    ":trackball:": "🖲️",
    ":minidisc:": "💽",
    ":floppy_disk:": "💾",
    ":cd:": "💿",
    ":dvd:": "📀",
    ":abacus:": "🧮",
    ":movie_camera_old:": "📽️",

    ":bulb:": "💡",
    ":flashlight:": "🔦",
    ":candle:": "🕯️",
    ":wastebasket:": "🗑️",
    ":oil_drum:": "🛢️",
    ":moneybag:": "💰",
    ":coin:": "🪙",
    ":yen:": "💴",
    ":dollar:": "💵",
    ":euro:": "💶",
    ":pound:": "💷",
    ":money_with_wings:": "💸",
    ":credit_card:": "💳",
    ":receipt:": "🧾",
    ":gem:": "💎",
    ":shopping_trolley:": "🛒",

    ":email:": "✉️",
    ":e-mail:": "📧",
    ":incoming_envelope:": "📨",
    ":envelope_with_arrow:": "📩",
    ":outbox_tray:": "📤",
    ":inbox_tray:": "📥",
    ":package:": "📦",
    ":label:": "🏷️",
    ":bookmark:": "🔖",
    ":link:": "🔗",
    ":paperclip:": "📎",
    ":pushpin:": "📌",
    ":round_pushpin:": "📍",
    ":pencil2:": "✏️",
    ":black_nib:": "✒️",
    ":memo:": "📝",
    ":notebook:": "📓",
    ":notebook_with_decorative_cover:": "📔",
    ":ledger:": "📒",
    ":closed_book:": "📕",
    ":book:": "📖",
    ":green_book:": "📗",
    ":blue_book:": "📘",
    ":orange_book:": "📙",
    ":books:": "📚",
    ":card_index_dividers:": "🗂️",
    ":newspaper:": "📰",
    ":newspaper_roll:": "🗞️",
    ":scroll:": "📜",
    ":page_with_curl:": "📃",
    ":page_facing_up:": "📄",
    ":bookmark_tabs:": "📑",
    ":bar_chart:": "📊",
    ":chart_with_upwards_trend:": "📈",
    ":chart_with_downwards_trend:": "📉",
    ":clipboard:": "📋",
    ":calendar:": "📅",
    ":date:": "📆",
    ":spiral_notepad:": "🗒️",
    ":spiral_calendar_pad:": "🗓️",
    ":card_index:": "📇",
    ":file_folder:": "📁",
    ":open_file_folder:": "📂",
    ":scissors:": "✂️",
    ":triangular_ruler:": "📐",
    ":straight_ruler:": "📏",
    ":lock:": "🔒",
    ":unlock:": "🔓",
    ":lock_with_ink_pen:": "🔏",
    ":closed_lock_with_key:": "🔐",
    ":key:": "🔑",
    ":old_key:": "🗝️",
    ":hammer:": "🔨",
    ":axe:": "🪓",
    ":pick:": "⛏️",
    ":hammer_and_pick:": "⚒️",
    ":hammer_and_wrench:": "🛠️",
    ":dagger_knife:": "🗡️",
    ":crossed_swords:": "⚔️",
    ":gun:": "🔫",
    ":boomerang:": "🪃",
    ":shield:": "🛡️",
    ":wrench:": "🔧",
    ":screwdriver:": "🪛",
    ":nut_and_bolt:": "🔩",
    ":gear:": "⚙️",
    ":clamp:": "🗜️",
    ":balance_scale:": "⚖️",
    ":probing_cane:": "🦯",
    ":toolbox:": "🧰",
    ":magnet:": "🧲",
    ":ladder:": "🪜",

    ":house:": "🏠",
    ":house_with_garden:": "🏡",
    ":office:": "🏢",
    ":post_office:": "🏣",
    ":hospital:": "🏥",
    ":bank:": "🏦",
    ":hotel:": "🏨",
    ":love_hotel:": "🏩",
    ":convenience_store:": "🏪",
    ":school:": "🏫",
    ":department_store:": "🏬",
    ":factory:": "🏭",
    ":japanese_castle:": "🏯",
    ":european_castle:": "🏰",
    ":wedding:": "💒",
    ":tokyo_tower:": "🗼",
    ":statue_of_liberty:": "🗽",
    ":church:": "⛪",
    ":mosque:": "🕌",
    ":hindu_temple:": "🛕",
    ":synagogue:": "🕍",
    ":shinto_shrine:": "⛩️",
    ":kaaba:": "🕋",
    ":mount_fuji:": "🗻",
    ":camping:": "🏕️",
    ":beach_with_umbrella:": "🏖️",
    ":desert:": "🏜️",
    ":island:": "🏝️",
    ":national_park:": "🏞️",
    ":sunrise_over_mountains:": "🌄",
    ":sunrise:": "🌅",
    ":city_sunset:": "🌆",
    ":city_sunrise:": "🌇",
    ":night_with_stars:": "🌃",
    ":bridge_at_night:": "🌉",

    ":red_car:": "🚗",
    ":taxi:": "🚕",
    ":blue_car:": "🚙",
    ":bus:": "🚌",
    ":trolleybus:": "🚎",
    ":race_car:": "🏎️",
    ":police_car:": "🚓",
    ":ambulance:": "🚑",
    ":fire_engine:": "🚒",
    ":minibus:": "🚐",
    ":truck:": "🚚",
    ":articulated_lorry:": "🚛",
    ":tractor:": "🚜",
    ":motorcycle:": "🏍️",
    ":bike:": "🚲",
    ":kick_scooter:": "🛴",
    ":skateboard:": "🛹",
    ":roller_skate:": "🛼",
    ":train:": "🚋",
    ":bullettrain_side:": "🚄",
    ":bullettrain_front:": "🚅",
    ":light_rail:": "🚈",
    ":station:": "🚉",
    ":tram:": "🚊",
    ":monorail:": "🚝",
    ":mountain_railway:": "🚞",
    ":steam_locomotive:": "🚂",
    ":railway_car:": "🚃",
    ":metro:": "🚇",
    ":suspension_railway:": "🚟",
    ":mountain_cableway:": "🚠",
    ":aerial_tramway:": "🚡",
    ":airplane:": "✈️",
    ":small_airplane:": "🛩️",
    ":flight_departure:": "🛫",
    ":flight_arrival:": "🛬",
    ":parachute:": "🪂",
    ":seat:": "💺",
    ":helicopter:": "🚁",
    ":rocket:": "🚀",
    ":satellite:": "🛰️",
    ":canoe:": "🛶",
    ":sailboat:": "⛵",
    ":speedboat:": "🚤",
    ":ferry:": "⛴️",
    ":ship:": "🚢",
    ":anchor:": "⚓",
    ":fuelpump:": "⛽",
    ":busstop:": "🚏",
    ":construction:": "🚧",
    ":traffic_light:": "🚥",
    ":vertical_traffic_light:": "🚦",

    ":watch:": "⌚",
    ":alarm_clock:": "⏰",
    ":stopwatch:": "⏱️",
    ":timer_clock:": "⏲️",
    ":mantelpiece_clock:": "🕰️",
    ":hourglass_flowing_sand:": "⏳",
    ":hourglass:": "⌛",
    ":calendar_spiral:": "🗓️",

    ":100:": "💯",
    ":heavy_check_mark:": "✔️",
    ":white_check_mark:": "✅",
    ":ballot_box_with_check:": "☑️",
    ":x:": "❌",
    ":negative_squared_cross_mark:": "❎",
    ":warning:": "⚠️",
    ":information_source:": "ℹ️",
    ":question:": "❓",
    ":grey_question:": "❔",
    ":grey_exclamation:": "❕",
    ":exclamation:": "❗",
    ":heavy_exclamation_mark:": "❗",
    ":bangbang:": "‼️",
    ":interrobang:": "⁉️",
    ":o:": "⭕",
    ":no_entry:": "⛔",
    ":no_entry_sign:": "🚫",
    ":underage:": "🔞",
    ":no_mobile_phones:": "📵",
    ":do_not_litter:": "🚯",
    ":non-potable_water:": "🚱",
    ":no_bicycles:": "🚳",
    ":no_smoking:": "🚭",
    ":children_crossing:": "🚸",
    ":beginner:": "🔰",
    ":recycle:": "♻️",
    ":arrow_up:": "⬆️",
    ":arrow_down:": "⬇️",
    ":arrow_left:": "⬅️",
    ":arrow_right:": "➡️",
    ":left_right_arrow:": "↔️",
    ":arrow_up_down:": "↕️",
    ":arrow_upper_left:": "↖️",
    ":arrow_upper_right:": "↗️",
    ":arrow_lower_right:": "↘️",
    ":arrow_lower_left:": "↙️",
    ":leftwards_arrow_with_hook:": "↩️",
    ":arrow_right_hook:": "↪️",
    ":arrows_clockwise:": "🔃",
    ":arrows_counterclockwise:": "🔄",
    ":repeat:": "🔁",
    ":repeat_one:": "🔂",
    ":hash:": "#️⃣",
    ":asterisk:": "*️⃣",
    ":zero:": "0️⃣",
    ":one:": "1️⃣",
    ":two:": "2️⃣",
    ":three:": "3️⃣",
    ":four:": "4️⃣",
    ":five:": "5️⃣",
    ":six:": "6️⃣",
    ":seven:": "7️⃣",
    ":eight:": "8️⃣",
    ":nine:": "9️⃣",
    ":keycap_ten:": "🔟",

    ":red_circle:": "🔴",
    ":orange_circle:": "🟠",
    ":yellow_circle:": "🟡",
    ":green_circle:": "🟢",
    ":blue_circle:": "🔵",
    ":purple_circle:": "🟣",
    ":brown_circle:": "🟤",
    ":black_circle:": "⚫",
    ":white_circle:": "⚪",
    ":red_square:": "🟥",
    ":orange_square:": "🟧",
    ":yellow_square:": "🟨",
    ":green_square:": "🟩",
    ":blue_square:": "🟦",
    ":purple_square:": "🟪",
    ":brown_square:": "🟫",
    ":black_large_square:": "⬛",
    ":white_large_square:": "⬜",
    ":black_medium_small_square:": "◾",
    ":white_medium_small_square:": "◽",
    ":black_small_square:": "▪️",
    ":white_small_square:": "▫️",
    ":large_blue_circle:": "🔵",
    ":large_blue_diamond:": "🔷",
    ":large_orange_diamond:": "🔶",
    ":small_blue_diamond:": "🔹",
    ":small_orange_diamond:": "🔸",
    ":small_red_triangle:": "🔺",
    ":small_red_triangle_down:": "🔻"
    };

    return String(text).replace(/:[a-z0-9_+\-]+:/gi, (match) => {
        return emojiMap[match] || match;
    });
}

  return {
    app,
    auth,
    db,
    storage,
    getQueryParam,
    generateId,
    generateToken,
    replaceSlackEmojiShortcodes
  };
})();